import PropTypes from 'prop-types';
import React from 'react';
import './styles.scss';

import Icon from '../widgets/Icon'


export const PopupAsideCustom = ({children, toggleTray, visible, width, title}) => {
  return (
  <aside className={`popup-aside ${!visible ? 'd-none' : ''} depth-5`} style={{width: width}}>
    <h3 className='title'>{title} <Icon onClick={toggleTray} className='icon-ban' name='ban'/></h3>
    <div className="popup">
      {children}
    </div>
  </aside>
  )
}

PopupAsideCustom.defaultProps = {
  width: '280px',
};

PopupAsideCustom.propTypes = {
  children: PropTypes.element,
  visible: PropTypes.bool.isRequired,
  width: PropTypes.string,
};

export default PopupAsideCustom;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/PopupAsideCustom/index.js